export class EventNameNormalizer {
  static normalize(target, eventName) {
    if (!!target && !!target.name) {
      return target.name.toUpperCase() + '_' + eventName;
    }
  }
}


/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/core/event/EventNameNormalizer.js
 **/